/* eslint-disable no-extra-parens,node/no-deprecated-api,no-undef,semi */
;(function () {
  const vueAuthImage = {}
  const axios = typeof require === 'function'
    ? require('axios')
    : window.Axios

  if (!axios) {
    throw new Error('[vue-auth-image] cannot locate Axios')
  }

  // Adjusted code so it can be reused in dynamic components
  function setImgSrc (el, binding) {
    if (binding.oldValue === undefined || binding.value !== binding.oldValue) {
      const imageUrl = binding.value
      el.setAttribute('v-auth-image', `'${imageUrl}'`)
      axios({
        method: 'get',
        url: imageUrl,
        responseType: 'arraybuffer'
      })
        .then(function (resp) {
          const mimeType = resp.headers['content-type'].toLowerCase()
          const imgBase64 = new Buffer(resp.data, 'binary').toString('base64')
          el.src = 'data:' + mimeType + ';base64,' + imgBase64
          el.removeAttribute('v-auth-image')
        }).catch((function () {
          el.src = imageUrl
        }))
    }
  }

  vueAuthImage.install = function (Vue) {
    Vue.directive('auth-image', {
      bind: function (el, binding) {
        setImgSrc(el, binding)
      },
      componentUpdated: function (el, binding) {
        setImgSrc(el, binding)
      }
    })
  }

  if (typeof exports === 'object') {
    module.exports = vueAuthImage
  } else if (typeof define === 'function' && define.amd) {
    define([], function () {
      return vueAuthImage
    })
  } else if (window.Vue) {
    window.VueAuthImage = vueAuthImage
    Vue.use(vueAuthImage)
  }
})()
